import { useState, useRef, useEffect } from 'react';
import { Box } from '@chakra-ui/react';

const ImageCompare = ({ beforeImage, afterImage }) => {
  const [sliderPosition, setSliderPosition] = useState(50);
  const containerRef = useRef(null);
  const isDragging = useRef(false);

  const handleMouseDown = () => {
    isDragging.current = true;
  };

  const handleMouseUp = () => {
    isDragging.current = false;
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    
    const container = containerRef.current;
    if (!container) return;
    
    const rect = container.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const containerWidth = rect.width;
    
    let position = (x / containerWidth) * 100;
    position = Math.max(0, Math.min(100, position));
    
    setSliderPosition(position);
  };

  const handleTouchMove = (e) => {
    if (!containerRef.current) return;
    
    const rect = containerRef.current.getBoundingClientRect();
    const x = e.touches[0].clientX - rect.left;
    const containerWidth = rect.width;
    
    let position = (x / containerWidth) * 100;
    position = Math.max(0, Math.min(100, position));
    
    setSliderPosition(position);
  };

  useEffect(() => {
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('mousemove', handleMouseMove);
    
    return () => {
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <Box
      ref={containerRef}
      position="relative"
      width="100%"
      height="100%"
      minHeight={{ base: "250px", md: "350px" }}
      overflow="hidden"
      borderRadius="md"
      boxShadow="xl"
      onMouseDown={handleMouseDown}
      onTouchMove={handleTouchMove}
      onTouchStart={() => {}}
      onTouchEnd={handleMouseUp}
      cursor="col-resize"
    >
      {/* Imagem "depois" (desenho) - visível em toda área */}
      <Box
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        backgroundImage={`url(${afterImage})`}
        backgroundSize="cover"
        backgroundPosition="center"
      />
      
      {/* Imagem "antes" (original) - visível apenas na área à esquerda do slider */}
      <Box
        position="absolute"
        top="0"
        left="0"
        width={`${sliderPosition}%`}
        height="100%"
        overflow="hidden"
      >
        <Box
          width={`${100 / (sliderPosition / 100)}%`}
          height="100%"
          backgroundImage={`url(${beforeImage})`}
          backgroundSize="cover"
          backgroundPosition="center"
        />
      </Box>
      
      {/* Linha do slider */}
      <Box
        position="absolute"
        top="0"
        left={`${sliderPosition}%`}
        width="4px"
        height="100%"
        bg="white"
        transform="translateX(-50%)"
        boxShadow="0 0 5px rgba(0, 0, 0, 0.5)"
      />
      
      {/* Controle do slider */}
      <Box
        position="absolute"
        top="50%"
        left={`${sliderPosition}%`}
        transform="translate(-50%, -50%)"
        width="40px"
        height="40px"
        borderRadius="full"
        bg="white"
        display="flex"
        alignItems="center"
        justifyContent="center"
        boxShadow="md"
        border="2px solid"
        borderColor="brand.primary"
        zIndex="1"
        _before={{
          content: '"⟷"',
          color: 'brand.primary',
          fontSize: '20px',
          fontWeight: 'bold',
        }}
      />
    </Box>
  );
};

export default ImageCompare;